// in order for vite to properly export these variables,
// this file extension MUST be .module.scss
// https://vitejs.dev/guide/features.html#css-modules
@import './whitelabel';
@import './premialab/defaults';
@import './premialab/extra-colors';

:export {
  $all-colors: map-merge(
    $map1: $theme-colors,
    $map2: $used-colors,
  );
  $all-colors: map-merge(
    $map1: $all-colors,
    $map2: $grays,
  );

  @each $name, $color in $all-colors {
    #{$name}: $color;
  }

  font: $platform-font;
  monospaceFont: $platform-monospace-font;
  cornerRadius: $border-radius;
}
